import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var FieldSet = (function (overrides) {
  return _objectSpread({
    spacing: 'major-3'
  }, _get(overrides, 'FieldSet', {}));
});

export default FieldSet;
